import React from 'react'
import { useTranslation } from 'react-i18next'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core'
import { Info } from '@material-ui/icons'
import { StandardCardTooltip } from '../../../../components/shared/standardCard/standardCardToolTip/standardCardToolTip'

export interface CupUsesCardProps {
  cupsHasMetersWithUses?: boolean
  isLoading?: boolean
}

export const CupUsesCard: React.FC<CupUsesCardProps> = ({
  cupsHasMetersWithUses,
  isLoading,
  children
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'cups'])

  return (
    <>
      <StandardCard title={t('cups:components.cupUsesCard.title')} isLoading={isLoading}>
        {children}
      </StandardCard>
      {cupsHasMetersWithUses && !isLoading && (
        <StandardCardTooltip
          tooltipTitle={t('cups:components.cupUsesCard.tooltip.icon')}
          tooltipCaption={t('cups:components.cupUsesCard.tooltip.caption')}
        />
      )}
    </>
  )
}
